<div class="skip-link">
    <a class="skip-link__link" [href]="skip2main()" i18n="@@skip-link-main">Skip to main content</a>
    &nbsp;
    <a class="skip-link__link" [href]="skip2footer()" i18n="@@skip-link-footer">or footer</a>
</div>

<div class="page-wrapper">
    @if (isDefaultLayout()) {
        <!-- Toolbar: volle Breite oben, behält Logo + Help + Profile -->
        <app-toolbar></app-toolbar>
    }
    @if (isMinimalLayout()) {
        <!-- Toolbar: volle Breite oben, behält Logo + Help + Profile -->
        <riege-minimal-toolbar></riege-minimal-toolbar>
    }

    <!-- Shell: Sidenav links + Content rechts -->
    <div class="main-view">
        @if (isDefaultLayout()) {
            <app-sidenav></app-sidenav>
        }

        <!-- Content-Area: scrollt unabhängig von der Sidenav -->
        <div class="main-view__content">
            <main
                id="main"
                class="main-content"
                [class.main-content--home]="isHome()"
                [class.is-logged-in]="isLoggedIn()">
                <riege-loading></riege-loading>

                <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
                @if (!isIframe) {
                    <router-outlet></router-outlet>
                }
            </main>

            @if (isDefaultLayout()) {
                @defer (on viewport(footer)) {
                    <app-breadcrumb></app-breadcrumb>
                }
            }

            <app-footer #footer id="footer"></app-footer>
            <!-- <app-scroll-top></app-scroll-top> -->
        </div>
    </div>
</div>
